(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ug-sticky-atc"] && !Shopify.designMode) return;
  try {
    class UgStickyAtc extends HTMLElement {
    #frame = 0;

    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      window.addEventListener('scroll', this.#requestUpdate, { passive: true });
      window.addEventListener('resize', this.#requestUpdate);
      this.#update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      window.removeEventListener('scroll', this.#requestUpdate);
      window.removeEventListener('resize', this.#requestUpdate);
      cancelAnimationFrame(this.#frame);
      document.documentElement.classList.remove('ug-sticky-atc-visible');
    }

    // Queried fresh each time: variant changes re-render the section and can replace these nodes.
    get #section() {
      return this.closest('.shopify-section') ?? document;
    }

    get #mainAddButton() {
      return this.#section.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
    }

    #requestUpdate = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update());
    };

    // Visible while the main Add to cart button is off screen. The state lives on <html> so it
    // survives the section re-render that follows a variant change.
    #update() {
      const button = this.#mainAddButton;
      if (!button) return;
      const rect = button.getBoundingClientRect();
      const offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
      document.documentElement.classList.toggle('ug-sticky-atc-visible', offScreen);
    }

    #onClick = (event) => {
      const sizeButton = event.target.closest('[data-value]');
      if (sizeButton && !sizeButton.disabled) {
        const input = [...this.#section.querySelectorAll('variant-picker input[type="radio"]')].find(
          (radio) => radio.value === sizeButton.dataset.value
        );
        if (!input) return;
        for (const button of this.querySelectorAll('[data-value]')) {
          button.setAttribute('aria-pressed', String(button === sizeButton));
        }
        input.click();
        return;
      }

      if (event.target.closest('[data-add]')) {
        this.#mainAddButton?.click();
      }
    };
  }

  if (!customElements.get('ug-sticky-atc')) customElements.define('ug-sticky-atc', UgStickyAtc);
  } catch(e) { console.error(e); }
})();

})();
